/* tslint:disable */

declare var Object: any;
export interface ForecastInterface {
  "zip": string;
  "lat"?: string;
  "lon"?: string;
  "city"?: string;
  "data": any;
  "dataType": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
}

export class Forecast implements ForecastInterface {
  "zip": string;
  "lat": string;
  "lon": string;
  "city": string;
  "data": any;
  "dataType": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ForecastInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Forecast`.
   */
  public static getModelName() {
    return "Forecast";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Forecast for dynamic purposes.
  **/
  public static factory(data: ForecastInterface): Forecast{
    return new Forecast(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Forecast',
      plural: 'Forecasts',
      path: 'Forecasts',
      idName: 'zip',
      properties: {
        "zip": {
          name: 'zip',
          type: 'string'
        },
        "lat": {
          name: 'lat',
          type: 'string'
        },
        "lon": {
          name: 'lon',
          type: 'string'
        },
        "city": {
          name: 'city',
          type: 'string'
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "dataType": {
          name: 'dataType',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Forecast.ts